import { useMutation } from "@apollo/client";
import { evictFields } from "../../../helpers/cache";
import { toast } from "react-toastify";
import { UPDATE_CUSTOMER } from "../customer.queries";
import {
  UpdateCustomerMutation,
  UpdateCustomerMutationVariables,
} from "../../../__generated__/UpdateCustomerMutation";

/**
 * Réserve un client aux administrateurs (§39).
 *
 * Le serveur refuse `isPrivate` si l'appelant n'est pas Admin — en `{ok: false}`
 * classique, pas en erreur GraphQL de transport comme les mutations du §29.
 */
export const useToggleCustomerPrivate = () => {
  const [mutate, { loading }] = useMutation<
    UpdateCustomerMutation,
    UpdateCustomerMutationVariables
  >(UPDATE_CUSTOMER, {
    refetchQueries: ["CustomersQuery", "CustomerQuery"],
    update(cache) {
      evictFields(cache, ["customer", "customers"]);
    },
  });

  const togglePrivate = async (id: number, isPrivate: boolean) => {
    if (loading) return;
    try {
      const { data } = await mutate({ variables: { id, input: { isPrivate } } });
      if (data?.updateCustomer?.ok) {
        toast.success(
          isPrivate
            ? "Le client est désormais réservé aux administrateurs"
            : "Le client est de nouveau visible par tous"
        );
      } else {
        toast.error(data?.updateCustomer?.error ?? "Une erreur est survenue");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };

  return { togglePrivate, loading };
};
